import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from '@emotion/styled'
import { Market } from 'api'
import { ModalConsumerProps, withModal } from '../modal'
import { LinkButton } from 'view/components/buttons'
import { SuspensionDialog } from './SuspensionDialog'
import {
  createMarketClosedSelector,
  createMarketPreOpenSelector,
  createPlatformSuspendedSelector,
  organisationSuspendedSelector,
  userSuspendedSelector
} from 'selectors/suspensionSelectors'
import { Locale, Translation } from 'locale'
import { iconSet } from 'view/components/icons'
import * as constants from 'view/styles/constants'

interface SuspensionIndicatorProps extends ModalConsumerProps {
  euMarketClosed: boolean
  euMarketPreOpen: boolean
  euPlatformSuspended: boolean
  usMarketClosed: boolean
  usMarketPreOpen: boolean
  usPlatformSuspended: boolean
  organisationSuspended: boolean
  userSuspended: boolean
}

const mapStateToProps = createStructuredSelector({
  euMarketClosed: createMarketClosedSelector(Market.EUROPE),
  euMarketPreOpen: createMarketPreOpenSelector(Market.EUROPE),
  euPlatformSuspended: createPlatformSuspendedSelector(Market.EUROPE),
  usMarketClosed: createMarketClosedSelector(Market.US),
  usMarketPreOpen: createMarketPreOpenSelector(Market.US),
  usPlatformSuspended: createPlatformSuspendedSelector(Market.US),
  organisationSuspended: organisationSuspendedSelector,
  userSuspended: userSuspendedSelector
})

const mapDispatchToProps = {}

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-right: 19px;
`

const LinkButtonStyled = styled(LinkButton)`
  margin-left: 10px;
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Bold};
  color: ${constants.CORE_PRIMARY_7};
`

class SuspensionIndicatorComponent extends React.Component<SuspensionIndicatorProps> {
  render() {
    const {
      euMarketClosed,
      euMarketPreOpen,
      euPlatformSuspended,
      usMarketClosed,
      usMarketPreOpen,
      usPlatformSuspended,
      organisationSuspended,
      userSuspended
    } = this.props
    const showSuspension =
      euMarketClosed ||
      euMarketPreOpen ||
      euPlatformSuspended ||
      usMarketClosed ||
      usMarketPreOpen ||
      usPlatformSuspended ||
      organisationSuspended ||
      userSuspended

    return (
      showSuspension && (
        <Container>
          {iconSet.suspensionIcon}
          <LinkButtonStyled dataTestId={'SuspensionIndicator-LinkButtonStyled-LinkSuspensions'} onClick={this.handleClick}>
            {Locale.translate(Translation.TC_SUSPENSIONS)}
          </LinkButtonStyled>
        </Container>
      )
    )
  }

  private handleClick = () => {
    this.props.showModal(<SuspensionDialog {...this.props} />)
  }
}

export const SuspensionIndicator = withModal(connect(mapStateToProps, mapDispatchToProps)(SuspensionIndicatorComponent))
